import React, { Component } from 'react';

class SplitInputContainer extends Component {

  renderLabel(label) {
    return label
    ? (
        <label>{label}</label>
      )
    : ''
  }

  renderErrorMessage = (errorMessages) => {
    let fieldsHaveAtLeastOneError = false;
    let numberOfErrors = 0;

    if (errorMessages) {
      for (const error of errorMessages) {
        if (error) {
          fieldsHaveAtLeastOneError = true;
          numberOfErrors++;
        }
      }
    }

    return fieldsHaveAtLeastOneError ? (
      <div className="input-error-message">
        Please complete {numberOfErrors > 1 ? 'these fields' : 'this field'}.
      </div>
    ) : '';
  }

  render() {
    const {
      children,
      errorMessages,
      label,
      showErrors,
      optionalClasses
    } = this.props;

    return (
      <div className={`split-input-container${optionalClasses ? ' ' +optionalClasses : ''}`}>
        {this.renderLabel(label)}
        {children}
        {showErrors && this.renderErrorMessage(errorMessages)}
      </div>
    )
  }
}


export default SplitInputContainer;



// WEBPACK FOOTER //
// ./src/components/Global/Forms/SplitInputContainer.js